import { actionTypes } from "./actions";
const initialState: InitialStateModel = {
  passwordSaved: false,
  userErrState: false,
  onVerifyStep: false,
  onMfaStep: false,
  loginErrorState: {
    status: 0,
    message: "",
  },
  createAccountErrorState: {
    status: 0,
    message: "",
  },
  resetPasswordErrorState: {
    status: 0,
    message: "",
  },
  resendVerificationEmailStatus: 0,
  reactivateAccountStatus: 0,
  createAccountInfo: {
    clientId: "",
    email: "",
    firmLogo: "",
    initialFirstName: "",
    initialLastName: "",
    firmName: "",
    firstName: "",
    id: "",
    lastName: "",
    redirectUri: "",
    urlStateParam: "",
    password: "",
    passwordConfirmation: "",
  },
};

const AuthAccountsReducer = (
  state: InitialStateModel = initialState,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case `${actionTypes.UPDATE_PASSWORD}_FULFILLED`:
      return {
        ...state,
        passwordSaved: true,
        userErrState: false,
      };

    case `${actionTypes.UPDATE_PASSWORD}_REJECTED`:
      return {
        ...state,
        resetPasswordErrorState: {
          status: action.payload.response.status,
          message: "Whoops! Something went wrong. Please try again later.",
        },
      };

    case actionTypes.TOGGLE_USER_ERR:
      return {
        ...state,
        userErrState: action.payload,
      };

    case `${actionTypes.CREATE_ACCOUNT}_FULFILLED`:
      return {
        ...state,
        onVerifyStep: true,
      };

    case `${actionTypes.RESEND_VERIFICATION_EMAIL}_FULFILLED`:
      return {
        ...state,
        resendVerificationEmailStatus: 201,
      };

    case `${actionTypes.RESEND_VERIFICATION_EMAIL}_REJECTED`:
      return {
        ...state,
        resendVerificationEmailStatus: action.payload.response.status,
      };

    case `${actionTypes.CREATE_ACCOUNT}_REJECTED`:
      return {
        ...state,
        userErrState: true,
      };

    case actionTypes.LOGIN_FAILURE:
      return {
        ...state,
        loginErrorState: {
          message: action.payload.data.message,
          status: action.payload.status,
        },
        userErrState: !(action.payload.status === 401),
      };

    case actionTypes.LOGIN_SUCCESSS:
      return {
        ...state,
      };

    case actionTypes.TOGGLE_MFA_STEP:
      return {
        ...state,
        onMfaStep: action.payload,
      };

    case actionTypes.CLEAR_ERROR_STATE:
      return {
        ...state,
        userErrState: false,
        loginErrorState: {
          status: 0,
          message: "",
        },
        createAccountErrorState: {
          status: 0,
          message: "",
        },
      };

    case `${actionTypes.REACTIVATE_ACCOUNT}_FULFILLED`:
      return {
        ...state,
        reactivateAccountStatus: 204,
      };

    case `${actionTypes.REACTIVATE_ACCOUNT}_REJECTED`:
      return {
        ...state,
        reactivateAccountStatus: 500,
      };

    case `${actionTypes.GET_CREATE_ACCOUNT_INFO}_FULFILLED`:
      return {
        ...state,
        createAccountInfo: {
          ...state.createAccountInfo,
          ...action.payload,
          initialFirstName: action.payload.firstName,
          initialLastName: action.payload.lastName,
        },
      };

    case actionTypes.UPDATE_USER_INPUT:
      return {
        ...state,
        createAccountInfo: {
          ...state.createAccountInfo,
          [action.payload.field]: action.payload.value,
        },
      };
    default:
      return state;
  }
};

export default AuthAccountsReducer;
